"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getONComplianceReportUrl = exports.createONComplianceReport = exports.overwriteONComplianceReportAPIUrl = exports.ON_COMPLIANCE_REPORT_API_URL = void 0;
const shared_1 = require("@getgreenline/shared");
exports.ON_COMPLIANCE_REPORT_API_URL = 'https://9eet8s5l70.execute-api.ca-central-1.amazonaws.com/staging';
function overwriteONComplianceReportAPIUrl(url) {
    exports.ON_COMPLIANCE_REPORT_API_URL = url;
}
exports.overwriteONComplianceReportAPIUrl = overwriteONComplianceReportAPIUrl;
const createONComplianceReport = (companyId, payload) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield shared_1.axios.post(`${exports.ON_COMPLIANCE_REPORT_API_URL}/companies/${companyId}/reports/compliance`, payload);
    return response.data;
});
exports.createONComplianceReport = createONComplianceReport;
const getONComplianceReportUrl = (companyId, fileName) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield shared_1.axios.get(`${exports.ON_COMPLIANCE_REPORT_API_URL}/companies/${companyId}/reports/compliance`, {
        params: { fileName },
    });
    return response.data;
});
exports.getONComplianceReportUrl = getONComplianceReportUrl;
//# sourceMappingURL=ONLambdaOneClickApi.js.map